<!--电梯配置-->
<template>
  <div class="cableTableList-body">
    <div class="condition-body">
      <div style="width: 15%;">
        <el-input v-model="search" size="medium" placeholder="输入关键字搜索" />
      </div>
      <el-button type="primary" size="small" @click="dialogClick('add')" style="margin-left: 10px;">添加电梯</el-button>
      <el-button type="danger" size="small" @click="batchDeletion()">批量删除</el-button>
    </div>
    <el-table
      :data="tableData.filter(data => !search || data.elevatorName.toLowerCase().includes(search.toLowerCase()))"
      border
      class="tableClass"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" align="center"> </el-table-column>
      <el-table-column type="index" align="center"> </el-table-column>
      <el-table-column prop="elevatorId" label="电梯id"> </el-table-column>
      <el-table-column prop="elevatorName" label="电梯名称"> </el-table-column>
      <el-table-column prop="elevatorUrl" label="电梯监控IP"> </el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          <span style="margin-left: 10px;">{{ new Date(scope.row.createTime).format('yyyy年MM月dd日') }}</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="dialogClick('编辑', scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="deleteColumn(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="display: flex; align-items: center; justify-content: flex-end; height: 10%;margin-right:2.3%">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="size"
        layout="total, prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible">
      <el-form :model="form" ref="form">
        <el-form-item
          label="电梯id"
          label-width="120px"
          prop="elevatorId"
          :rules="[{ required: true, message: '不能为空', trigger: 'blur' }]"
        >
          <el-input
            v-model="form.elevatorId"
            autocomplete="off"
            style="width: 70%;"
            placeholder="请输入id"
            :disabled="saveType == 1"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="电梯名称"
          label-width="120px"
          prop="elevatorName"
          :rules="[{ required: true, message: '不能为空', trigger: 'blur' }]"
        >
          <el-input
            v-model="form.elevatorName"
            autocomplete="off"
            style="width: 70%;"
            placeholder="请输入名称"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          label="电梯监控IP"
          label-width="120px"
          prop="elevatorUrl"
          :rules="[{ required: true, message: '不能为空', trigger: 'blur' }]"
        >
          <el-input
            type="textarea"
            v-model="form.elevatorUrl"
            autocomplete="off"
            style="width: 70%;"
            placeholder="请输入IP"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="saveElevatorInfo" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      search: '',
      tableData: [],
      dialogFormVisible: false,
      form: {
        elevatorId: '',
        elevatorName: '',
        elevatorUrl: ''
      },
      pageIndex: 1,
      size: 10,
      total: 0,
      saveType: 0, //保存电梯监控0为添加 1为编辑
      title: '添加',
      selectItemList: [] //选中多个
    };
  },
  created() {},
  mounted() {
    this.initData();
  },
  destroyed() {},
  computed: {},
  watch: {
    pageIndex(nv, ov) {
      this.initData();
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.selectItemList = val;
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.initData();
    },
    batchDeletion() {
      if (isempty(this.selectItemList)) {
        this.$message({
          message: '请选择要删除的项',
          type: 'warning'
        });
        return;
      }
      let ids = '';
      this.selectItemList.forEach((item, index) => {
        if (index + 1 == this.selectItemList.length) {
          ids += item.id;
        } else {
          ids += item.id + ',';
        }
      });
      this.$alert('', '确定删除选中的数据吗？', {
        confirmButtonText: '确定',
        callback: action => {
          this.$api.elevatorMonitoringApi.deleteElevatorInfo(
            ids,
            respon => {
              if (!isempty(respon)) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.initData();
              }
            },
            err => {
              this.$message({
                type: 'error',
                message: err
              });
            }
          );
        }
      });
    },
    initData() {
      this.$api.elevatorMonitoringApi.list(
        this.size,
        this.pageIndex,
        respon => {
          if (!isempty(respon.data)) {
            this.tableData = respon.data;
            this.total = respon.total;
          }
        },
        err => {
          this.$message({
            type: 'error',
            message: err
          });
        }
      );
    },
    saveElevatorInfo() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let message = '添加';
          if (this.saveType == 1) {
            message = '修改';
          }
          this.$api.elevatorMonitoringApi.saveElevatorInfo(
            this.form.elevatorId,
            this.form.elevatorName,
            this.form.elevatorUrl,
            this.form.id,
            respon => {
              this.dialogFormVisible = false;
              if (!isempty(respon)) {
                this.$message({
                  message: message + '成功',
                  type: 'success'
                });
                if (this.pageIndex == 1) {
                  this.initData();
                } else {
                  this.pageIndex = 1;
                }
              }
            },
            err => {
              this.$message({
                type: 'error',
                message: err
              });
            }
          );
        }
      });
    },
    dialogClick(type, row) {
      if (type == 'add') {
        (this.form = {
          elevatorId: '',
          elevatorName: '',
          elevatorUrl: '',
          id: ''
        }),
          (this.saveType = 0);
      } else {
        this.title = '编辑';
        this.saveType = 1;
        this.form = {
          elevatorId: row.elevatorId,
          elevatorName: row.elevatorName,
          elevatorUrl: row.elevatorUrl,
          id: row.id
        };
      }
      this.dialogFormVisible = true;
    },
    deleteColumn(row) {
      this.$alert('', '确定删除此列吗？', {
        confirmButtonText: '确定',
        callback: action => {
          this.$api.elevatorMonitoringApi.deleteElevatorInfo(
            row.id,
            respon => {
              if (!isempty(respon)) {
                this.initData();
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
              }
            },
            err => {
              this.$message({
                type: 'error',
                message: err
              });
            }
          );
        }
      });
    }
  }
};
</script>

<style>
.cableTableList-body {
  margin: 0 auto;
  width: 95%;
  height: 100%;
}

.condition-body {
  height: 8%;
  display: flex;
  align-items: center;
}

.cableTableList-body .el-dialog {
  width: 30%;
}
.tableClass,
.condition-body {
  width: 95%;
  margin: 0 auto;
}
.tableClass {
  z-index: 1;
}
</style>
